import { useOffreService, useSociete } from '@europrocurement/l2d-domain';
import {
    FormaliteApiApiFormalitesGetCollectionRequest,
    FormaliteJsonldFormaliteRead,
} from '@europrocurement/l2d-domain/openApi/ApiOffre';

export type OffreFormalite = FormaliteJsonldFormaliteRead & Record<string, unknown>;

const useOffreFormalite = () => {
    const { formaliteApi } = useOffreService();
    let searchFormaliteTimeout: number | undefined;
    const xIdSociete = useSociete();

    const searchOfferFormalite = (): Promise<Array<OffreFormalite>> =>
        new Promise((resolve, reject) => {
            clearTimeout(searchFormaliteTimeout);
            let requestParameters: FormaliteApiApiFormalitesGetCollectionRequest = {};
            if (xIdSociete !== null) {
                requestParameters = { xIdSociete, ...requestParameters };
            }

            searchFormaliteTimeout = setTimeout(() => {
                formaliteApi
                    .apiFormalitesGetCollection(requestParameters)
                    .then((res) => resolve(res.data['hydra:member'] as Array<OffreFormalite>))
                    .catch((err) => {
                        reject(err);
                    });
            }, 300);
        });

    return { searchOfferFormalite };
};

export { useOffreFormalite };
